import ServiceBase from "./ServiceBase"

const resource = "/orders"

export default
	{
		getOrder(id)
		{
			return ServiceBase.get(resource + "/" + id)
		},
		updateOrder(payload)
		{
			return ServiceBase.put(resource + "/" + payload.order.id + "/" + payload.personid, payload.order)
		},
		addOrder(payload)
		{
			return ServiceBase.post(resource + "/" + payload.personid, payload.order)
		},
		deleteOrder(id)
		{
			return ServiceBase.delete(resource + "/" + id)
		},
		getOrderingPDF(personid, agreementid, filename)
		{
			return ServiceBase.get(resource + "/pdf/" + agreementid + "/" + personid,
				{
					responseType: "arraybuffer",
					headers: {
						'Access-Control-Expose-Headers': '*',
					}
				})
				.then(response =>
				{
					let blob = new Blob([response.data], { type: "application/pdf" })
					let link = document.createElement("a")
					link.href = window.URL.createObjectURL(blob)
					link.download = filename;
					link.click()
					return response
				})
				.catch(error =>
				{
					return error
				})
		},
		generateOrderingPDF(agreementid, persongroupid, personid)
		{
			return ServiceBase.get(resource + "/generatepdf/" + (agreementid ? agreementid : "0") + "/" + (persongroupid ? persongroupid : "0") + "/" + (personid ? personid : "0"))
				.then(response =>
				{
					return response
				})
				.catch(error =>
				{
					return error
				})
		},
		getGeneratedFiles(payload)
		{
			return ServiceBase.get(resource + "/generatedfiles/" + payload.customerid + "/" + payload.agreementid)
		},
		downloadGeneratedFile(fileid, filename)
		{
			return ServiceBase.get(resource + "/generatedfiles/files/" + fileid,
				{
					responseType: "arraybuffer",
					headers: {
						'Access-Control-Expose-Headers': '*',
					}
				})
				.then(response =>
				{
					let blob = new Blob([response.data], { type: "application/pdf" })
					let link = document.createElement("a")
					link.href = window.URL.createObjectURL(blob)
					link.download = filename;
					link.click()
					return response
				})
				.catch(error =>
				{
					return error
				})
		},
		getPersonOrderInformation(customerid, agreementid, personid, persongroupid, orderid)
		{
			return ServiceBase.get(resource + "/personorderinfo/" + customerid + "/" + agreementid + "/" + personid + "/" + persongroupid + "/" + orderid)
		},
		getOrdersByPersonGroup(customerid, persongroupid)
		{
			return ServiceBase.get(resource + "/ordersbypersongroup/" + customerid + "/" + persongroupid)
		},
		sendWebshopLinkToClient(personid)
		{
			return ServiceBase.get(resource + "/sendwebshoplink/" + + personid)
		},
		sendNewWebshopCodeToClient(personid)
		{
			return ServiceBase.get(resource + "/sendnewwebshopcode/" + personid)
		},
		sendWebshopLinksToClients(payload)
		{
			return ServiceBase.get(resource + "/sendwebshoplinks/" + payload.agreementid + "/" + payload.customerid + "/" + (payload.sendtoall ? "true/" : "false/") + (payload.persongroupid ? payload.persongroupid : "0"))
		},
		sendReceiptToClient(payload)
		{
			return ServiceBase.get(resource + "/sendreceipttoclient/" + payload)
		},
		sendPaymentlinkToClient(payload)
		{
			return ServiceBase.get(resource + "/sendpaymentlinktoclient/" + payload.orderid + "/" + payload.personid)
		},
		sendPaymentReminderToClient(payload)
		{
			return ServiceBase.get(resource + "/sendpaymentremindertoclient/" + payload.orderid + "/" + payload.personid + "/" + payload.reminder)
		},
		findOrders(payload)
		{
			return ServiceBase.get(resource + "/findorder/" + (payload.agreementid ? payload.agreementid : 0) + "/" + (payload.customerid ? payload.customerid : 0) + "/" + (payload.persongroupid ? payload.persongroupid : 0) + "/"+ payload.findorderinput)
		},
		getOrders(payload)
		{
			return ServiceBase.get(resource + "/orders/" + (payload.pageindex ? payload.pageindex : 1) + "/" + (payload.pagesize ? payload.pagesize : 30) + "/" + (payload.orderstatus ? payload.orderstatus : 0) + "/" + (payload.sorttype ? payload.sorttype : "datedesc") + "/" + payload.customerid + "/" + payload.agreementid + "/" + payload.daterange + "/" + (payload.searchtext ? encodeURI(payload.searchtext) : ""))
		},
		createOrderCopy(payload)
		{
			return ServiceBase.get(resource + "/createordercopy/" + payload.orderid + "/" + payload.personid)
		}
	}